import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/shared/lib'
import { Spinner } from '@/shared/ui/spinner'

type Variant = 'primary' | 'accent' | 'ghost' | 'danger'
type Size = 'md' | 'sm'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  pending?: boolean
  children: ReactNode
}

const variants: Record<Variant, string> = {
  primary: 'bg-pill-active-bg text-pill-active-fg hover:opacity-90',
  accent: 'bg-accent text-accent-fg hover:opacity-90',
  ghost: 'bg-raise text-app-fg hover:bg-hover',
  danger: 'bg-danger/10 text-danger hover:bg-danger/20',
}

const sizes: Record<Size, string> = {
  md: 'h-11 px-5 text-body-sm',
  sm: 'h-9 px-4 text-body-sm',
}

export function Button({
  variant = 'ghost',
  size = 'md',
  pending = false,
  className,
  children,
  disabled,
  type,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type ?? 'button'}
      disabled={disabled || pending}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-full font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    >
      {pending && <Spinner size={16} />}
      {children}
    </button>
  )
}
